module.exports = __webpack_public_path__ + "img/icon_ks_bg.fd9f07b2.png";